import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

import { ApiError, memberApi } from "@/lib/api";
import type { MemberVerifyResponse } from "@/types/api";

export function VerifyPage() {
  const [params] = useSearchParams();
  const token = params.get("token");

  const mutation = useMutation<MemberVerifyResponse, ApiError, string>({
    mutationFn: memberApi.verify,
  });

  useEffect(() => {
    if (token && !mutation.data && !mutation.error && !mutation.isPending) {
      mutation.mutate(token);
    }
  }, [token, mutation]);

  return (
    <div className="mx-auto max-w-2xl px-6 py-16 text-center">
      {!token && (
        <>
          <h1 className="mb-3 font-display text-h1 uppercase text-primary">Token fehlt</h1>
          <p className="text-body-sm text-ink-soft">
            Der Bestätigungs-Link ist unvollständig. Bitte erneut auf den Link in der Email klicken.
          </p>
        </>
      )}
      {token && mutation.isPending && (
        <p className="text-body-sm text-ink-muted">Email wird bestätigt …</p>
      )}
      {mutation.isSuccess && (
        <>
          <h1 className="mb-3 font-display text-h1 uppercase text-primary">
            {mutation.data.already_verified ? "Bereits bestätigt" : "Email bestätigt"}
          </h1>
          <p className="mb-6 text-lead text-ink-soft">
            {mutation.data.message ?? "Du kannst dich jetzt einloggen."}
          </p>
          <Link
            to="/konto/login"
            className="inline-block rounded bg-primary px-5 py-2 text-body-sm font-semibold text-white hover:bg-primary-dark"
          >
            Zum Login
          </Link>
        </>
      )}
      {mutation.isError && (
        <>
          <h1 className="mb-3 font-display text-h1 uppercase text-primary">
            Bestätigung fehlgeschlagen
          </h1>
          <p className="mb-6 text-body-sm text-danger">{mutation.error.message}</p>
          <Link to="/konto/registrieren" className="text-primary underline">
            Erneut registrieren
          </Link>
        </>
      )}
    </div>
  );
}
